import { calProductsPriceObejct } from '@/utils'
/**
 * 장바구니에 있는 상품을 반환한다.
 * @param {*} state
 * @returns {Array}
 */
const cartProducts = (state) => {
  return state.items
}
const cartProductsAvailable = (stete, getters) => {
  return getters.cartProducts.filter(el => el.productStatus === 2)
}
/**
 * 장바구니에 선택된 상품을 반환한다.
 * @param {*} state
 * @returns {Array}
 */
const checkedCartProducts = (state) => {
  return state.items.filter(el=>el.checked)
}
/**
 * 장바구니에 있는 상품들의 모든 가격을 더한 값을 반환한다.
 * @param {*} state
 * @param {*} getters
 * @returns {Object}
 */
const cartTotalPrice = (state, getters) => calProductsPriceObejct(getters.checkedCartProducts)
/**
 * 상품들의 모두 check되었는지 여부를 반환한다.
 * @param {*} state
 * @param {*} getters
 * @returns {boolean}
 */
const isAllChecked = (state, getters) => {
  return !!getters.cartProductsAvailable.length && getters.cartProductsAvailable.every(el => el.checked)
}
/**
 * 장바구니에 있는 상품의 갯수를 반환한다.
 * @param {*} state
 * @param {*} getters
 * @returns {Number}
 */
const cartUniqueQuantity = (state, getters) => getters.cartProducts.length

/**
 * 상점별 구매가능 금액을 리스트를 반환한다.
 * @param {*} state
 */
const purchaseCheckList = state => state.purchaseCheckList

export default {
  cartProducts,
  checkedCartProducts,
  cartTotalPrice,
  cartUniqueQuantity,
  isAllChecked,
  cartProductsAvailable,
  purchaseCheckList
}
